import React from 'react'
import { Row } from '@fs/zion-ui'
import mapSvg from '../../../../assets/map.svg'

export default function PlaceReportsNoRegionSelectedMap({ message }) {
  return (
    <Row>
      <div style={{ position: 'relative', textAlign: 'center' }}>
        <img src={mapSvg} alt="World Map" style={{ width: '100%' }} />
        <div
          style={{
            position: 'absolute',
            top: '50%',
            insetInlineStart: '50%',
            transform: 'translate(-50%, -50%)',
            color: 'white',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            padding: '10px',
            borderRadius: '5px',
            fontSize: '2em',
          }}
        >
          {message}
        </div>
      </div>
    </Row>
  )
}
